import { useContext } from 'react'
import { Modal } from 'antd'
import { DefPluginContext, SHOW_DEF_UPLOAD_POPUP } from '../context/context'
import DefForm from './DefForm'
import { useIntl } from 'react-intl'

const DefFormModal = (props) => {
  const [defPluginState, defPluginDispatch] = useContext(DefPluginContext)
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({ id: 'defPlugin.title' })}
      open={defPluginState?.show_upload_popup}
      centered={true}
      onCancel={() => {
        defPluginDispatch({ type: SHOW_DEF_UPLOAD_POPUP, data: false })
        props.getDefPluginList(null, true)
      }}
      width="50%"
      footer={null}
      className="def-plugin-upload"
      destroyOnHidden
    >
      <DefForm getDefPluginList={props.getDefPluginList} />
    </Modal>
  )
}

export default DefFormModal
